import { Component, Vue ,Prop } from 'vue-property-decorator'
@Component
export default class luckDraw extends Vue {
    @Prop() private roomData!: any;
    @Prop() private videoStatus!: any;
    
    api:any={
      setPrize: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/luck/set",
      prizeStatistics: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/luck/count",
      drawPrize: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/luck",
    }
    luckDrawData:any={
      luck_cond: 0,//参与条件下标
      luck_term:'',//发言词
      winners:'',//中奖人数
      status: 0,//步骤状态
    }
    titleName:String ='抽奖设置'
    prizeData:any={};//中奖信息
    conditionArr:any=[
      '固定发言词'
    ]
    isClick = false
    mounted() {
      // let luckDrawData:any = sessionStorage.getItem("luckDrawData");
      // if(luckDrawData){
      //   this.luckDrawData = JSON.parse(luckDrawData)
      // }
      if(this.roomData.luck && JSON.stringify(this.roomData.luck) != '{}'){
        this.luckDrawData = this.roomData.luck;
        this.luckDrawData.luck_cond = this.luckDrawData.luck_cond-1; 
        if(this.luckDrawData.status == 3){
          this.titleName = "中奖名单"
        }
      }
    }
    selectCondition(index:number){//选择参与条件
      this.luckDrawData.luck_cond = index;
    }
    numberFormatter(val:any){//中奖人数最多40人
      val = val?Number(val):val
      if(!val && val != '' || val<0){
        val=1
      }else if(val>40){
        val = 40
      }
      this.luckDrawData.winners = val
    }
    preservation(){//保存抽奖信息
      if(!this.luckDrawData.luck_term){
        this.$toast({
          message: '请输入固定发言词',
          className: 'topIndex',
          duration: 2000
        });
        return false
      }else if(!this.luckDrawData.winners  || this.luckDrawData.winners<=0){
        this.$toast({
          message: '请输入中奖人数，最多40人',
          className: 'topIndex',
          duration: 2000
        });
        return false
      }else if(this.roomData.live_status != 1 && this.videoStatus.roomStatus != '1'){
        this.$toast({
          message: '直播中才可以设置抽奖哟，请先去开播吧',
          className: 'topIndex',
          duration: 2000
        });
        return false;
      }
      if (this.isClick) {
        return false
      }
      this.isClick = true
      this.fetch(
        {
            url: this.api.setPrize,
            data: {
              room_id: this.$route.params.id,
              luck_cond: this.luckDrawData.luck_cond+1,
              luck_term:this.luckDrawData.luck_term,
              winners:this.luckDrawData.winners || 1
            },
            method:'POST'
        }).then((data:any) => {
          this.isClick = false
          this.luckDrawData.status = 1;
          // sessionStorage.setItem("luckDrawData",JSON.stringify(this.luckDrawData))
      }).catch((res:any)=>{
        this.isClick = false
        this.$toast({
            message: res.msg,
            className: 'topIndex',
            duration: 2000
        });
      })
    }
    prizeStatistics(){//开始抽奖统计
      if (this.isClick) {
        return false
      }
      this.isClick = true
      this.fetch(
        {
            url: this.api.prizeStatistics,
            data: {
              room_id: this.$route.params.id
            },
            method:'POST'
        }).then((data:any) => {
          this.isClick = false
          this.$toast({
            message: '开始统计中',
            className: 'topIndex',
            duration: 2000
          });
          this.luckDrawData.status = 2;
          // sessionStorage.setItem("luckDrawData",JSON.stringify(this.luckDrawData))
      }).catch((res:any)=>{
        this.isClick = false
        this.$toast({
            message: res.msg,
            className: 'topIndex',
            duration: 2000
        });
      })
    }
    drawPrize(){//开奖
      if (this.isClick) {
        return false
      }
      this.isClick = true
      this.fetch(
        {
            url: this.api.drawPrize,
            data: {
              room_id: this.$route.params.id
            },
            method:'POST'
        }).then((data:any) => {
          this.isClick = false
          this.prizeData=data;
          this.luckDrawData.status = 3;
          this.titleName = '中奖名单'
          // sessionStorage.setItem("luckDrawData",JSON.stringify(this.luckDrawData))
      }).catch((res:any)=>{
        this.isClick = false
        this.$toast({
            message: res.msg,
            className: 'topIndex',
            duration: 2000
        });
      })
    }
    determine(){//确定   清除本次抽奖信息
      this.luckDrawData.luck_term='';//发言词
      this.luckDrawData.winners='';//中奖人数
      this.luckDrawData.status = 0;//步骤状态
      this.prizeData={};//中奖信息
      this.titleName = '抽奖设置'
      // sessionStorage.removeItem("luckDrawData")
    }
    close(){
      if(this.luckDrawData.status == 3){
        this.determine()
      }
      this.$emit('setPrize',false)
    }
}


